<template>
  <div class="status">
    <header>
      <h3>需求状态分布</h3>
      <span>(工单创建时间)</span>
    </header>
    <div ref="target" style="width: 100%" :style="{ height }"></div>
    <div class="board">
      <div
        class="board-item"
        v-for="item in boardList"
        :key="item.name"
        :style="{ backgroundColor: item.bgColor }">
        <div class="board-item-name">
          <span :style="{ backgroundColor: item.color }"></span>
          <span>{{ item.name }}</span>
        </div>
        <div class="board-item-num" :style="{ color: item.color }">
          {{ item.num }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { debounce } from "lodash"
import PieChart from "@/views/workOrder/dashboard/components/PieChart.vue"
import API from "@/api/workOrder/board.js"
import { mapState } from "vuex"
import * as echarts from "echarts"
export default {
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    PieChart,
  },
  data() {
    return {
      myChart: null,
      height: "400px",
      boardList: [
        {
          name: "待指派",
          num: 89,
          color: "#6b7280",
          bgColor: "#f9fafb",
        },
        {
          name: "待上传",
          num: 142,
          color: "#165dff",
          bgColor: "#f0f6fe",
        },
        {
          name: "待审核",
          num: 184,
          color: "#ff7d00",
          bgColor: "#fdfcea",
        },
        {
          name: "已通过",
          num: 756,
          color: "#00b42a",
          bgColor: "#f2fcf5",
        },
        {
          name: "被拒绝",
          num: 62,
          color: "#f53f3f",
          bgColor: "#fcf2f2",
        },
        {
          name: "待修改",
          num: 73,
          color: "#a855f7",
          bgColor: "#f9f5fe",
        },
      ],
      // "unassigned_material_num" 待指派
      // "no_upload_material_num" 待上传
      // "no_audit_material_num" 待审核
      // "pass_material_num"  已通过
      // "rejected_num" 被拒绝
      // "rejected_no_modify_num" 待修改
      legendData: ["待指派", "待上传", "待审核", "已通过", "被拒绝", "待修改"],
      seriesData: [
        {
          value: 30,
          name: "待指派",
          itemStyle: {
            color: "#6b7280",
          },
        },
        {
          value: 40,
          name: "待上传",
          itemStyle: {
            color: "#165dff",
          },
        },
        {
          value: 50,
          name: "待审核",
          itemStyle: {
            color: "#ff7d00",
          },
        },
        {
          value: 70,
          name: "已通过",
          itemStyle: {
            color: "#00b42a",
          },
        },
        {
          value: 10,
          name: "被拒绝",
          itemStyle: {
            color: "#f53f3f",
          },
        },
        {
          value: 50,
          name: "待修改",
          itemStyle: {
            color: "#a855f7",
          },
        },
      ],
    }
  },
  computed: {
    ...mapState({
      sidebarOpened: (state) => state.app.sidebar.opened,
    }),
  },
  watch: {
    form: {
      handler: debounce(function (newVal, oldVal) {
        let params = {
          ...this.form,
          range_time:
            this.form.range_time?.length > 0
              ? this.form?.range_time.join("/")
              : "",
        }
        API.getDemandStatus(params).then((res) => {
          if (res.code === 200) {
            this.boardList[0].num = res.data.unassigned_material_num
            this.boardList[1].num = res.data.no_upload_material_num
            this.boardList[2].num = res.data.no_audit_material_num
            this.boardList[3].num = res.data.pass_material_num
            this.boardList[4].num = res.data.rejected_num
            this.boardList[5].num = res.data.rejected_no_modify_num
            this.seriesData[0].value = res.data.unassigned_material_num
            this.seriesData[1].value = res.data.no_upload_material_num
            this.seriesData[2].value = res.data.no_audit_material_num
            this.seriesData[3].value = res.data.pass_material_num
            this.seriesData[4].value = res.data.rejected_num
            this.seriesData[5].value = res.data.rejected_no_modify_num
            this.myChart = echarts.init(this.$refs.target)
            this.renderChart()
            window.addEventListener("resize", this.handleResize)
          }
        })
      },500),
      deep: true,
      immediate: true,
    },
    // 监听侧边栏状态变化，重新渲染图表
    sidebarOpened() {
      this.renderChart()
      setTimeout(() => {
        if (this.myChart) {
          this.handleResize()
        }
      }, 200)
    },
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize)
    this.myChart && this.myChart.dispose()
  },

  methods: {
    renderChart() {
      const options = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          data: this.legendData,
          bottom: 0,
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "5%",
          top: "10%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: this.seriesData.map((item) => item.name),
          axisLabel: {
            interval: 0,
            rotate: 30,
          },
        },
        yAxis: {
          type: "value",
          name: "数量",
        },
        series: [
          {
            name: "需求数量",
            type: "bar",
            barWidth: "60%",
            data: this.seriesData.map((item) => ({
              value: item.value,
              itemStyle: item.itemStyle,
            })),
          },
        ],
      }
      this.myChart && this.myChart.setOption(options)
    },

    handleResize() {
      this.myChart && this.myChart.resize()
    },
  },
}
</script>

<style scoped lang="scss">
.status {
  header {
    display: flex;
    align-items: center;
    height: 32px;
    span {
      color: #a9afb9;
      margin-left: 10px;
    }
  }
  .board {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;

    .board-item {
      width: 30%;

      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 10px;
      border-radius: 10px;
      margin-bottom: 20px;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
      .board-item-name {
        span:first-child {
          display: inline-block;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          margin-right: 6px;
        }
      }
      .board-item-num {
        font-weight: bold;
        font-size: 16px;
        margin-top: 6px;
      }
    }
  }
}
</style>
